import { render, staticRenderFns } from "./Bloco5Noticias.vue?vue&type=template&id=3dee10d2&scoped=true&"
import script from "./Bloco5Noticias.vue?vue&type=script&lang=js&"
export * from "./Bloco5Noticias.vue?vue&type=script&lang=js&"
import style0 from "./Bloco5Noticias.vue?vue&type=style&index=0&id=3dee10d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dee10d2",
  null
  
)

export default component.exports